export const BASE_URL = "https://gameserver.api.nudgenow.com/"

export const CLIENT_URL = "https://api.unicohub.com/api/gameResults"
export const CLIENT_US_URL = "https://us.api.unicohub.com/api/gameResults"
export const CLIENT_URL_NUDGE = "https://pointsystem.api.nudgenow.com/api/v1/post_match/pm/update"